import { render, staticRenderFns } from "./LeaveRegionContainer.vue?vue&type=template&id=390ca50f"
import script from "./LeaveRegionContainer.vue?vue&type=script&lang=js"
export * from "./LeaveRegionContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports